import _ from 'underscore'
import { zonedTimeToUtc } from 'date-fns-tz'

const LOCALE = 'en-US';
const TZ_ORIGIN = 'America/New_York';
const TZ_STANDARD = 'UTC';

export default {
  /**
   * Take a datetime ISO string returned from API and convert it to 'Month day, Year' format.
   * This is not the same function as the one in Reservation System with the same name.
   * @param dt Datetime in EST (business-defined), e.g. 2019-10-31T00:00:00
   * @returns {string}
   */
  formatMonthDayYear(dt) {
    // backend returns sticker date as null or 0001-mm-dd... if not found
    if (_.isEmpty(dt) || dt.startsWith('0001')) {
      return '';
    }

    // first, convert EST to standard UTC
    const utcDt = zonedTimeToUtc(dt, TZ_ORIGIN);
    return utcDt.toLocaleDateString(LOCALE, { timeZone: TZ_STANDARD, year: 'numeric', month: 'long', day: 'numeric' });
  },
}
